// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterSocialPinterest: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 24,
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 24 24" width={size} height={size}>
        <path
            fill="currentColor"
            d="M23.25 12c0 6.422-5.203 11.625-11.625 11.625-1.2 0-2.353-.183-3.44-.52.473-.774 1.18-2.04 1.443-3.047.14-.544.722-2.766.722-2.766.38.722 1.486 1.336 2.663 1.336 3.506 0 6.032-3.225 6.032-7.233 0-3.839-3.136-6.712-7.167-6.712-5.016 0-7.683 3.365-7.683 7.036 0 1.706.91 3.83 2.358 4.504.22.104.338.057.39-.154.037-.16.234-.952.323-1.317a.35.35 0 0 0-.08-.333c-.473-.586-.858-1.655-.858-2.653 0-2.564 1.94-5.044 5.25-5.044 2.855 0 4.856 1.945 4.856 4.73 0 3.145-1.589 5.325-3.656 5.325-1.139 0-1.997-.943-1.72-2.1.328-1.383.96-2.874.96-3.872 0-.89-.477-1.636-1.471-1.636-1.167 0-2.105 1.204-2.105 2.822 0 1.03.347 1.725.347 1.725S7.641 18.58 7.43 19.49c-.234 1.003-.14 2.418-.041 3.337C3.066 21.136 0 16.927 0 12 0 5.578 5.203.375 11.625.375S23.25 5.578 23.25 12"
        />
    </svg>
);

export default React.memo(FooterSocialPinterest);
